
import React from 'react'
import {Routes,Route} from 'react-router-dom'
import Home from '../Pages/Home'
import NotFound from '../Pages/NotFound'
import Progress from '../Pages/progress'
import Trainer from "../Pages/Trainer"
// import RegisterPage from '../Pages/Register'


function AllRouter() {
    return (
        <>
        
        <Routes>
            <Route path = '/' element = {<Home/>}></Route>
            <Route path = '*' element={<NotFound/>}></Route>
            <Route path = "/progress" element={<Progress/>}></Route>
            <Route path="/trainer" element = {<Trainer/>}></Route>
           
        </Routes>

        </>
    )
}
export default AllRouter;